import React, { FC, useCallback, useEffect, useState } from 'react';
import Image from 'frontastic/lib/image';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { semiLargeDesktop, tablet } from 'helpers/utils/screensizes';
import { Product, Variant } from 'shared/types/product';
import { discardRepeatedValues } from '../product-details/helpers/discardRepeatedValues';
import { filterAttributeBasedVariants } from '../product-details/helpers/filterAttributeBasedVariants';
import debounce from 'lodash.debounce';
interface ColorSwatchProps {
  variants: Variant[];
  product?: Product;
  setSelectedVariant?: any;
}
const ColorSwatches: FC<ColorSwatchProps> = ({ variants, setSelectedVariant, product }) => {
  //   const variants = ['GunMetal', 'Chrome', 'BrushedBrass', 'additional'];
  const [variantsToUse, setVariantsToUse] = useState<Variant[]>();
  const [showPlusTwo, setShowPlusTwo] = useState(false);
  const swatchCount = 3;
  useEffect(() => {
    const filteredVariants: Variant[] = discardRepeatedValues(variants, 'colour');
    setVariantsToUse(filteredVariants);
    if (variantsToUse) {
      setShowPlusTwo(variantsToUse?.length > 3);
    }
  }, [variants]);
  useEffect(() => {
    if (variantsToUse) {
      setShowPlusTwo(variantsToUse?.length > 3);
    }
  }, [variantsToUse]);
  const updateVariant = useCallback(
    debounce((variant: Variant) => setSelectedVariant(variant), 100),
    [],
  );
  return (
    <div className="flex flex-row">
      {variantsToUse?.slice(0, swatchCount)?.map((variant, index) => (
        <>
          {variant?.attributes?.colour !== 'Not Applicable' && (
            <div
              onMouseEnter={() => {
                updateVariant(variantsToUse?.filter((item) => item.id === variant.id)?.[0]);
              }}
              onMouseLeave={() => {
                updateVariant(
                  variantsToUse?.filter((variant) => variant.id === product?.masterVariantID)?.[0] ||
                    variantsToUse?.[0],
                );
              }}
              key={variant.id}
              className={`relative lg:w-20 lg:w-20 xl:w-20 xl:w-20 2xl:w-20 2xl:w-20 md:h-20 md:w-20 w-15 h-15 rounded-full 2xl:h-24 2xl:w-24 ${
                index === swatchCount - 1 && showPlusTwo ? 'border border-[#333] bg-white' : ''
              } mr-2`}
            >
              <Image
                src={`/images/colorswatches/swatch_${variant?.attributes?.colour
                  .replaceAll(' ', '')
                  .replaceAll('/', '')}.png`}
                alt={`/images/colorswatches/swatch_${variant?.attributes?.colour.replaceAll(' ', '')}.png`}
                style={{ objectFit: 'cover', objectPosition: 'center' }}
                fill
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                priority
              />
            </div>
          )}
        </>
      ))}
      {showPlusTwo && variantsToUse && (
        <div
          key="plusTwo"
          className="relative mr-2 flex items-center justify-center text-8 md:text-10 lg:text-10 xl:text-10 2xl:text-10 text-[#333] 2xl:h-24 w-15  2xl:w-24"
        >
          <span className="mt-1 ml-4 text-8 hover:underline">View More</span>
        </div>
      )}
    </div>
  );
};
export default ColorSwatches;